import { render } from "./OrderInformation.vue?vue&type=template&id=1e662546"
import script from "./OrderInformation.vue?vue&type=script&lang=js"
export * from "./OrderInformation.vue?vue&type=script&lang=js"

import "./OrderInformation.vue?vue&type=style&index=0&id=1e662546&lang=css"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__